const creativesLibraryAPIPrefix = (accountId, creativeId) => `/${accountId}/creatives/${creativeId}`;

export const creativesLibraryApiFactory = ({ callGetApi, callPutApi, callPostApi, callDeleteApi }) => ({
    updateLibraryCreative: (accountId, creativeId, changes) =>
        callPutApi(creativesLibraryAPIPrefix(accountId, creativeId), changes),
    deleteLibraryCreative: (accountName, creativeId) =>
        callDeleteApi(creativesLibraryAPIPrefix(accountName, creativeId)),
});
